import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import useFormState$1 from './useFormState.js';

/**
 * Conditionally render child components using the current form state
 */

var FieldCondition = function FieldCondition(_ref) {
  var condition = _ref.condition,
      field = _ref.field,
      match = _ref.match,
      children = _ref.children;
  var formState = useFormState$1();
  var conditionValid = typeof condition === "function" ? !!condition(formState) : !!condition;
  var matchValid = field !== undefined && match !== undefined ? typeof match === "function" ? !!match(formState.fields[field], formState) : formState.fields[field] === match : false;

  if (!conditionValid && !matchValid) {
    return null;
  } else if (React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children)) {
    return children;
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
};

FieldCondition.propTypes = {
  condition: _pt.oneOfType([_pt.bool, _pt.func]),
  field: _pt.string,
  match: _pt.any,
  children: _pt.node
};
var FieldCondition$1 = FieldCondition;

export { FieldCondition$1 as default };
